import { ApplicationRef, ChangeDetectorRef, Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  public localTheme: string = this.localStorageService.getItem('theme') ?? "light";
  public themeStatus: string= this.localTheme.replaceAll(/["\\]/g, '');
  // Variables that being used by css
  public themeColor: string = '';
  isSwitchOn:boolean = false; // Flag for switch status
  isDarkMode: boolean = false; // Flag for dark mode

  // Variable that will force the nav-bar SVG's to change theme
  private forceNavBarToChange = new Subject<void>;
  forceNavBarToChange$ = this.forceNavBarToChange.asObservable();

  constructor(public localStorageService: LocalStorageService) { }

    // Get current theme class for UI
    getThemeClass(isModal: boolean = false): string {
      // 1) read + sanitize
      const raw = this.localStorageService.getItem('theme') ?? 'light';
      const themeName = raw.replaceAll(/["\\]/g, '') === 'dark' ? 'dark' : 'light';

      // 2) set flags
      this.isSwitchOn = (themeName === 'dark');

      // 3) map to classes
      const themeClass = themeName === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark';

      // 4) modal color (compare against themeName, not the class)
      if (isModal) {
        const themeColor = themeName === 'dark' ? 'lightgray' : 'black';
        document.documentElement.style.setProperty('--theme-color', themeColor);
      }

      return themeClass;
    }

}
